// extracted by mini-css-extract-plugin
export default {"container":"tooltip_container__tRSI0","text":"tooltip_text__hThuF","icon":"tooltip_icon__5-NGH"};